export default {
  default_browser_tag: "FoodAmigos - Order online",
  seo: {
    title: "{{name}} - order food online in {{city}}",
    description:
      "{{name}} in {{city}}. Official Menu. Save money and order online.",
  },
};
